<template>
  <div>
    <el-dialog
        :visible.sync="isOpenUpdateTemplateAppDialog"
        width="1720px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="3vh"
        title="Cập nhật gói giao diện App"
        border
    >
      <el-form
          label-width="140px"
          :model="updateTemplateAppRequest"
          label-position="left"
          :rules="rules"
          ref="updateTemplateAppRequest"
      >
        <el-row :gutter="50">
          <el-col :span="10">
            <div class="grid-content">
              <el-form-item label="Tên template" prop="nameTemplate">
                <el-input
                    v-model="updateTemplateAppRequest.nameTemplate"
                    placeholder="Nhập tên template"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="14">
            <div class="grid-content">
              <el-form-item label="Mô tả" prop="descriptionTemplate">
                <el-input
                    v-model="updateTemplateAppRequest.descriptionTemplate"
                    placeholder="Nhập mô tả"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="Phiên bản" prop="version">
              <span>{{ updateTemplateAppRequest.version }}</span>
              <el-input-number v-model="version" style="margin-left: 10px" :min="0"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div class="grid-content">
              <el-form-item label="Loại App" prop="appType" style="margin-left: 20px;">
                <h4 class="app_name">
                  {{ updateTemplateAppRequest.appType }}
                </h4>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <div class="grid-content">
              <el-form-item  label="Màu chữ">
                <el-row>
                  <el-color-picker
                      v-model="colorText"
                      :predefine="defaultColors"
                      color-format="hex"
                  >
                  </el-color-picker>
<!--                  <el-col :span="3" v-for="(color, index) in colors" :key="index" :style="{ marginLeft: index === 0 ? '0' : '1px' }">-->
<!--                    <div-->
<!--                        :style="{-->
<!--                backgroundColor: color,-->
<!--                height: '20px',-->
<!--                width: '20px',-->
<!--                borderRadius: '5px',-->
<!--                border: '1px solid gray',-->
<!--                marginTop: '10px'-->
<!--              }">-->
<!--                    </div>-->
<!--                  </el-col>-->
                </el-row>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
<!--        <el-row>-->
<!--          <el-col :span="11">-->
<!--            <div style="margin-left: 153px; margin-top: -10px; margin-bottom: 20px">-->
<!--              <el-radio-group v-model="colorText" style="display: flex; gap: 10px">-->
<!--                <el-radio :label="'#FFFFFF'" style="transform: scale(1.5); margin: 0 0 0 6px;">-->
<!--                  <span style="visibility: hidden;">#FFFFFF</span>-->
<!--                </el-radio>-->
<!--                <el-radio :label="'#464646'" style="transform: scale(1.5); margin: 0 0 0 -10px;">-->
<!--                  <span style="visibility: hidden;">#464646</span>-->
<!--                </el-radio>-->
<!--                <el-radio :label="'#FB7369'" style="transform: scale(1.5); margin: 0 0 0 -9px;">-->
<!--                  <span style="visibility: hidden;">#FB7369</span>-->
<!--                </el-radio>-->
<!--                <el-radio :label="'#C6C6C9'" style="transform: scale(1.5); margin: 0 0 0 -8px;">-->
<!--                  <span style="visibility: hidden;">#C6C6C9</span>-->
<!--                </el-radio>-->
<!--                <el-radio :label="'#5B96FB'" style="transform: scale(1.5); margin: 0 0 0 -14px;">-->
<!--                  <span style="visibility: hidden;">#5B96FB</span>-->
<!--                </el-radio>-->
<!--                <el-radio :label="'#F59B00'" style="transform: scale(1.5); margin: 0 0 0 -10px;">-->
<!--                  <span style="visibility: hidden;">#F59B00</span>-->
<!--                </el-radio>-->
<!--                <el-radio :label="'#E96F91'" style="transform: scale(1.5); margin: 0 0 0 -10px;">-->
<!--                  <span style="visibility: hidden;">#E96F91</span>-->
<!--                </el-radio>-->
<!--              </el-radio-group>-->
<!--            </div>-->
<!--          </el-col>-->
<!--        </el-row>-->
        <el-row v-if="typePackage === 'ticket' && updateTemplateAppRequest.appType === 'plus'">
          <el-col :span="9">
            <el-form-item label="Màn hình">
              <el-select v-model="displayTicket" placeholder="Chọn màn hình" @change="handleChangeDisplayTicket"
                         style="width: 228px">
                <el-option
                    style="width: 200px"
                    v-for="item in listDisplayTicket"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!--        Bảng chọn ảnh -->

        <!--   PLUS   -->
        <el-table
            v-if="updateTemplateAppRequest.appType === 'plus' && typePackage === 'template' "
            ref="multipleTable"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255,255,255, 0)"
            highlight-current-row
            :data="plusScreenList"
            :header-cell-style="tableHeaderColor"
            :max-height="500"
            border
        >
          <el-table-column
              type="index"
              label="STT"
              width="80"
              align="center"
          ></el-table-column>
          <el-table-column
              label="Màn hình"
              align="center"
              width="200px"
          >
            <template v-slot:default="scope">
              <span>{{ scope.row.value }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Ảnh hiện tại" align="center">
            <template v-slot:default="scope">
              <div>
                <el-image
                    :src="scope.row.urlKeep"
                    style="width: 150px; height: 150px;"
                    class="el-image-opacity"
                    @click="showTemplateDefault(scope.row.urlKeep)"
                ></el-image>
              </div>

            </template>
          </el-table-column>
          <el-table-column
              label="Chọn ảnh mới"
          >
            <template v-slot:default="scope">
              <el-upload
                  action="/api/upload/"
                  list-type="picture-card"
                  :auto-upload="false"
                  :file-list="getFileList(scope.row.file)"
                  :on-change="(file) => handleChangePicture(scope.row, file)"
                  :on-remove="(file) => handleRemove(scope.row, file)"
                  :before-remove="(file) => beforeRemove(scope.row, file)"
                  ref="upload"
                  accept="image/jpeg,image/png"
                  :disabled="scope.row.showFile === false"
                  :limit="1"
              >
                <div v-if="scope.row.showFile === true">
                  <i slot="default" class="el-icon-plus" style="font-style: normal">Thêm ảnh</i>
                </div>
                <div slot="file" slot-scope="{ file }">
                  <TagFlag title="Mới"/>
                  <img class="el-upload-list__item-thumbnail" :src="scope.row.url" alt/>
                  <span class="el-upload-list__item-actions">
                    <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview(scope.row, file)"
                    >
                        <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                        @click="handleRemove(scope.row, file)"
                        v-if="!scope.row.disabled"
                        class="el-upload-list__item-delete"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <el-dialog width="30%" :visible.sync="scope.row.dialogImg">
                <img width="100%" :src="scope.row.url" alt/>
              </el-dialog>
            </template>
          </el-table-column>
          <el-table-column label="Tác vụ" width="100px" align="center">
            <template v-slot:default="scope">
              <el-button
                  :disabled="scope.row.id === null  || scope.row.urlKeep === ''"
                  size="mini"
                  type="danger"
                  @click="deleteTemplateSchool(scope.row.id)"
              >Xóa
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!--   APP TEACHER   -->
        <el-table
            v-if="updateTemplateAppRequest.appType === 'teacher'&&typePackage === 'template'"
            ref="multipleTable"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255,255,255, 0)"
            highlight-current-row
            :data="teacherScreenList"
            :header-cell-style="tableHeaderColor"
            :max-height="500"
            border
        >
          <el-table-column
              type="index"
              label="STT"
              width="80"
              align="center"
          ></el-table-column>
          <el-table-column
              label="Màn hình"
              align="center"
              width="200px"
          >
            <template v-slot:default="scope">
              <span>{{ scope.row.value }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Ảnh hiện tại" align="center">
            <template v-slot:default="scope">
              <div>
                <el-image
                    :src="scope.row.urlKeep"
                    style="width: 150px; height: 150px;"
                    class="el-image-opacity"
                    @click="showTemplateDefault(scope.row.urlKeep)"
                ></el-image>
              </div>

            </template>
          </el-table-column>
          <el-table-column
              label="Chọn ảnh mới"
          >
            <template v-slot:default="scope">
              <el-upload
                  action="/api/upload/"
                  list-type="picture-card"
                  :auto-upload="false"
                  :file-list="getFileList(scope.row.file)"
                  :on-change="(file) => handleChangePicture(scope.row, file)"
                  :on-remove="(file) => handleRemove(scope.row, file)"
                  :before-remove="(file) => beforeRemove(scope.row, file)"
                  ref="upload"
                  accept="image/jpeg,image/png"
                  :disabled="scope.row.showFile === false"
              >
                <div v-if="scope.row.showFile === true">
                  <i slot="default" class="el-icon-plus" style="font-style: normal">Thêm ảnh</i>
                </div>
                <div slot="file" slot-scope="{ file }">
                  <TagFlag title="Mới"/>
                  <img class="el-upload-list__item-thumbnail" :src="scope.row.url" alt/>
                  <span class="el-upload-list__item-actions">
                    <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview(scope.row, file)"
                    >
                        <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                        @click="handleRemove(scope.row, file)"
                        v-if="!scope.row.disabled"
                        class="el-upload-list__item-delete"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <el-dialog width="30%" :visible.sync="scope.row.dialogImg">
                <img width="100%" :src="scope.row.url" alt/>
              </el-dialog>
            </template>
          </el-table-column>
          <el-table-column label="Tác vụ" width="100px" align="center">
            <template v-slot:default="scope">
              <el-button
                  :disabled="scope.row.id === null  || scope.row.urlKeep === ''"
                  size="mini"
                  type="danger"
                  @click="deleteTemplateSchool(scope.row.id)"
              >Xóa
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!--  APP PARENT  -->
        <el-table
            v-if="updateTemplateAppRequest.appType === 'parent'&&typePackage === 'template'"
            ref="multipleTable"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255,255,255, 0)"
            highlight-current-row
            :data="parentScreenList"
            :header-cell-style="tableHeaderColor"
            :max-height="500"
            border
        >
          <el-table-column
              type="index"
              label="STT"
              width="80"
              align="center"
          ></el-table-column>
          <el-table-column
              label="Màn hình"
              align="center"
              width="200px"
          >
            <template v-slot:default="scope">
              <span>{{ scope.row.value }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Ảnh hiện tại" align="center">
            <template v-slot:default="scope">
              <div>
                <el-image
                    :src="scope.row.urlKeep"
                    style="width: 150px; height: 150px;"
                    class="el-image-opacity"
                    @click="showTemplateDefault(scope.row.urlKeep)"
                ></el-image>
              </div>

            </template>
          </el-table-column>
          <el-table-column
              label="Chọn ảnh mới"
          >
            <template v-slot:default="scope">
              <el-upload
                  action="/api/upload/"
                  list-type="picture-card"
                  :auto-upload="false"
                  :file-list="getFileList(scope.row.file)"
                  :on-change="(file) => handleChangePicture(scope.row, file)"
                  :on-remove="(file) => handleRemove(scope.row, file)"
                  :before-remove="(file) => beforeRemove(scope.row, file)"
                  ref="upload"
                  accept="image/jpeg,image/png"
                  :disabled="scope.row.showFile === false"
              >
                <div v-if="scope.row.showFile === true">
                  <i slot="default" class="el-icon-plus" style="font-style: normal">Thêm ảnh</i>
                </div>
                <div slot="file" slot-scope="{ file }">
                  <TagFlag title="Mới"/>
                  <img class="el-upload-list__item-thumbnail" :src="scope.row.url" alt/>
                  <span class="el-upload-list__item-actions">
                    <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview(scope.row, file)"
                    >
                        <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                        @click="handleRemove(scope.row, file)"
                        v-if="!scope.row.disabled"
                        class="el-upload-list__item-delete"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <el-dialog width="30%" :visible.sync="scope.row.dialogImg">
                <img width="100%" :src="scope.row.url" alt/>
              </el-dialog>
            </template>
          </el-table-column>
          <el-table-column label="Tác vụ" width="100px" align="center">
            <template v-slot:default="scope">
              <el-button
                  :disabled="scope.row.id === null  || scope.row.urlKeep === ''"
                  size="mini"
                  type="danger"
                  @click="deleteTemplateSchool(scope.row.id)"
              >Xóa
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="tab-infor-button">
          <el-button
              type="success"
              size="medium"
              :loading="loadingButton"
              mini
              @click="submitForm('updateTemplateAppRequest')"
          >
            <i class="el-icon-circle-check"/>
            <span>Lưu</span>
          </el-button>
          <el-button
              type="danger"
              size="medium"
              @click="closeDialog()"
          >
            <i class="el-icon-circle-close"/>
            <span>Đóng</span>
          </el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog width="30%" :visible.sync="dialogVisibleTemplateDefault">
      <img width="100%" :src="urlTemplateDefault" alt/>
    </el-dialog>
  </div>

</template>

<script>

import TemplateService from "@/services/TemplateService";
import {
  defaultColors,
  listDisplayTicket,
  listTicketRequest,
  parentScreenList,
  plusScreenList,
  teacherScreenList
} from "@/constant/listTemplate";
import templateConfigMixin from "@/global/mixinTemplate/templateConfig.mixin";
import TagFlag from "@/views/tag/TagFlag.vue";


export default {
  components: {TagFlag},
  props: {
    isOpenUpdateTemplateAppDialog: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      currentSlideIndex: 0,
      itemsToShow: 5,
      currentImageDialog: {
        currentImage: "",
        isDialogVisible: false,
      },
      dialogVisibleTemplateDefault: false,
      urlTemplateDefault: '',
      agentList: "",
      checkedKeepPhoto: true,
      disabled: false,
      loadingData: true,
      loadingButton: false,
      dialogVisiblePicture: false,
      showUpload: false,
      version: 0,
      updateTemplateAppRequest: {
        id: "",
        nameTemplate: "",
        descriptionTemplate: "",
        appType: "plus",
        listMap: {},
        version: '',
      },
      plusScreenList,
      teacherScreenList,
      parentScreenList,
      listIdDelete: [],
      listDisplayTicket,
      displayTicket: 1,
      typePackage: "template",
      listTicketLearnShow: [],
      listTicketEatShow: [],
      listTicketSleepShow: [],
      listTicketToiletShow: [],
      listTicketHealthyShow: [],
      listTicketCommentShow: [],
      listTicketWeekShow: [],
      listTicketMonthShow: [],
      listTicketPeriodicShow: [],
      listTicketRequest,
      titleTicket: '',
      listTicketUpdate: [],
      fileListTicket: [],
      dialogVisibleTicket: false,
      dialogImageUrlTicket: '',
      listTicketLearn: [],
      listTicketEat: [],
      listTicketSleep: [],
      listTicketToilet: [],
      listTicketHealthy: [],
      listTicketComment: [],
      listTicketWeek: [],
      listTicketMonth: [],
      listTicketPeriodic: [],
      listIdTicketDelete: [],
      colorText:"#FFFFFF",
      defaultColors,
      rules: {
        nameTemplate: [
          {
            required: true,
            message: "Không được để trống",
            trigger: "blur",
          },
        ],
        version: [
          {
            required: true,
            message: "Không được để trống",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    maxIndex() {
      return Math.ceil(this.listTicketUpdate.length / this.itemsToShow) - 1;
    }
  },
  mixins: [
    templateConfigMixin
  ],
  methods: {
    nextSlide() {
      if (this.currentSlideIndex < this.maxIndex) {
        ++this.currentSlideIndex;
      }
    },
    prevSlide() {
      if (this.currentSlideIndex > 0) {
        --this.currentSlideIndex;
      } else {
        this.currentSlideIndex = -this.maxIndex;
      }
    },
    handleShowImageDialog(url) {
      this.currentImageDialog.currentImage = url;
      this.currentImageDialog.isDialogVisible = true;
    },

    getFileList(file) {
      return file ? [file] : [];
    },
    showTemplateDefault(url) {
      this.dialogVisibleTemplateDefault = true
      this.urlTemplateDefault = url
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },

    closeDialog() {
      this.clearAllData();
      this.$refs["updateTemplateAppRequest"].resetFields();
      this.$emit("dialog-close");
    },
    closeDialogByButton(fromData) {
      this.clearAllData();
      this.$refs[fromData].resetFields();
      this.$emit("dialog-close");
    },

    clearAllData() {
      this.colorText = "#FFFFFF"
      this.listTicketLearn = []
      this.listTicketEat = []
      this.listTicketSleep = []
      this.listTicketToilet = []
      this.listTicketHealthy = []
      this.listTicketComment = []
      this.listTicketWeek = []
      this.listTicketMonth = []
      this.listTicketPeriodic = []
      this.typePackage = "template"
      this.listTicketUpdate = []
      this.fileListTicket = []
      this.listIdDelete = []
      this.listIdTicketDelete = []
      this.agentList = ""
      this.checkedKeepPhoto = true
      this.loadingData = true
      this.loadingButton = false
      this.dialogVisiblePicture = false
      this.showUpload = false
      this.updateTemplateAppRequest =
          {
            nameTemplate: "",
            descriptionTemplate: "",
            appType: "plus",
            listMap: {},
          }
      this.handleClearList()
    },

    handleClearList() {
      for (let i = 0; i < this.plusScreenList.length; i++) {
        this.plusScreenList[i].file = null;
        this.plusScreenList[i].url = '';
        this.plusScreenList[i].showFile = true;
        this.plusScreenList[i].id = null
        this.plusScreenList[i].showFile = true
        this.plusScreenList[i].disabled = false
        this.plusScreenList[i].urlKeep = ''
      }
      for (let i = 0; i < this.teacherScreenList.length; i++) {
        this.teacherScreenList[i].file = null;
        this.teacherScreenList[i].url = "";
        this.teacherScreenList[i].showFile = true;
        this.teacherScreenList[i].id = null
        this.teacherScreenList[i].showFile = true
        this.teacherScreenList[i].disabled = false
        this.teacherScreenList[i].urlKeep = ''
      }
      for (let i = 0; i < this.parentScreenList.length; i++) {
        this.parentScreenList[i].file = null;
        this.parentScreenList[i].url = '';
        this.parentScreenList[i].showFile = true;
        this.teacherScreenList[i].id = null
        this.teacherScreenList[i].showFile = true
        this.teacherScreenList[i].disabled = false
        this.teacherScreenList[i].urlKeep = ''
      }
    },

    async getDataInitialUpdateTemplateDialog(row) {
      let idTemplate = row.id
      this.updateTemplateAppRequest.id = row.id;
      this.updateTemplateAppRequest.descriptionTemplate = row.descriptionTemplate;
      this.updateTemplateAppRequest.nameTemplate = row.nameTemplate;
      this.updateTemplateAppRequest.appType = row.appType;
      this.updateTemplateAppRequest.version = row.version
      this.colorText = row.colorText
      // Tách chuỗi dựa trên dấu chấm
      let parts = this.updateTemplateAppRequest.version.split('.');
      this.version = parseInt(parts[parts.length - 1], 10);
      let dataList = [];
      await TemplateService.getDetailTemplateMasterSchool(idTemplate)
          .then((resp) => {
            dataList = resp.data.data.listTemplate;
            this.listTicketLearnShow = resp.data.data.listTicketLearn
            this.listTicketEatShow = resp.data.data.listTicketEat
            this.listTicketSleepShow = resp.data.data.listTicketSleep
            this.listTicketToiletShow = resp.data.data.listTicketToilet
            this.listTicketHealthyShow = resp.data.data.listTicketHealthy
            this.listTicketCommentShow = resp.data.data.listTicketComment
            this.listTicketWeekShow = resp.data.data.listTicketWeek
            this.listTicketMonthShow = resp.data.data.listTicketMonth
            this.listTicketPeriodicShow = resp.data.data.listTicketPeriodic
            if (this.updateTemplateAppRequest.appType === "plus") {
              for (let i = 0; i < this.plusScreenList.length; i++) {
                let plusTemplate = this.plusScreenList[i];
                let key = this.plusScreenList[i].key;
                for (let j = 0; j < dataList.length; j++) {
                  let data = dataList[j];
                  if (data.namePicture === key) {
                    plusTemplate.id = data.id
                    plusTemplate.url = data.urlPicture
                    plusTemplate.urlKeep = data.urlPicture
                    plusTemplate.showFile = true
                  }
                }
              }

            } else if (this.updateTemplateAppRequest.appType === "teacher") {
              for (let i = 0; i < this.teacherScreenList.length; i++) {
                let teacherTemplate = this.teacherScreenList[i];
                let key = this.teacherScreenList[i].key;
                for (let j = 0; j < dataList.length; j++) {
                  let data = dataList[j];
                  if (data.namePicture === key) {
                    teacherTemplate.id = data.id
                    teacherTemplate.url = data.urlPicture
                    teacherTemplate.urlKeep = data.urlPicture
                    teacherTemplate.showFile = true
                  }
                }
              }
            } else {
              for (let i = 0; i < this.parentScreenList.length; i++) {
                let parentTemplate = this.parentScreenList[i];
                let key = this.parentScreenList[i].key;
                for (let j = 0; j < dataList.length; j++) {
                  let data = dataList[j];
                  if (data.namePicture === key) {
                    parentTemplate.id = data.id
                    parentTemplate.url = data.urlPicture
                    parentTemplate.urlKeep = data.urlPicture
                    parentTemplate.showFile = true
                  }
                }
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    deleteTemplateSchool(id) {
      this.listIdDelete.push(id)
      for (let i = 0; i < this.plusScreenList.length; i++) {
        if (this.plusScreenList[i].id === id) {
          this.plusScreenList[i].urlKeep = ''
        }
      }
      for (let i = 0; i < this.teacherScreenList.length; i++) {
        if (this.teacherScreenList[i].id === id) {
          this.teacherScreenList[i].urlKeep = ''
        }
      }
      for (let i = 0; i < this.parentScreenList.length; i++) {
        if (this.parentScreenList[i].id === id) {
          this.parentScreenList[i].urlKeep = ''
        }
      }
    },
    submitForm(fromData) {
      this.$refs[fromData].validate((valid) => {
        if (valid) {
          const formData = new FormData();
          formData.append("id", this.updateTemplateAppRequest.id);
          formData.append("nameTemplate", this.updateTemplateAppRequest.nameTemplate);
          formData.append("descriptionTemplate", this.updateTemplateAppRequest.descriptionTemplate);
          formData.append("appType", this.updateTemplateAppRequest.appType);
          formData.append("colorText", this.colorText);
          if (this.listIdTicketDelete.length >= 0) {
            this.listIdDelete.push(...this.listIdTicketDelete)
          }
          formData.append("listIdDelete", this.listIdDelete);
          // Tách chuỗi dựa trên dấu chấm
          let parts = this.updateTemplateAppRequest.version.split('.');
          parts[parts.length - 1] = this.version.toString();
          this.updateTemplateAppRequest.version = parts.join('.');
          formData.append("version", this.updateTemplateAppRequest.version);
          if (this.updateTemplateAppRequest.appType === "plus") {
            for (let i = 0; i < this.plusScreenList.length; i++) {
              if (this.plusScreenList[i].file != null) {
                formData.append(`listMap[${this.plusScreenList[i].key}]`, this.plusScreenList[i].file.raw);
              }
            }
          } else if (this.updateTemplateAppRequest.appType === "teacher") {
            for (let i = 0; i < this.teacherScreenList.length; i++) {
              if (this.teacherScreenList[i].file != null) {
                formData.append(`listMap[${this.teacherScreenList[i].key}]`, this.teacherScreenList[i].file.raw);
              }
            }
          } else {
            for (let i = 0; i < this.parentScreenList.length; i++) {
              if (this.parentScreenList[i].file != null) {
                formData.append(`listMap[${this.parentScreenList[i].key}]`, this.parentScreenList[i].file.raw);
              }
            }
          }
          if (this.updateTemplateAppRequest.appType === "plus") {
            this.addImageTicketFormData(formData, this.listTicketLearn, this.listTicketEat, this.listTicketSleep, this.listTicketToilet,
                this.listTicketHealthy, this.listTicketComment, this.listTicketWeek, this.listTicketMonth, this.listTicketPeriodic)
          }
          this.loadingButton = true;
          TemplateService.updateTemplateMasterSchool(formData)
              .then((resp) => {
                this.$message({
                  message: resp.data.message,
                  type: "success",
                });
                setTimeout(() => {
                  this.closeDialog();
                }, 500);
              })
              .catch((err) => {
                this.$message({
                  message: err.response.data.message,
                  type: "error",
                });
              })
              .finally(() => {
                setTimeout(() => {
                  this.loadingButton = false;
                }, 500);
              });
        }
      });
    },

    handleRemove(row, file) {
      console.log(file)
      if (this.updateTemplateAppRequest.appType === "plus") {
        for (let i = 0; i < this.plusScreenList.length; i++) {
          if (this.plusScreenList[i].key === row.key) {
            this.plusScreenList[i].file = null;
            this.plusScreenList[i].url = '';
            this.plusScreenList[i].showFile = true;
          }
        }
      } else if (this.updateTemplateAppRequest.appType === "teacher") {
        for (let i = 0; i < this.teacherScreenList.length; i++) {
          if (this.teacherScreenList[i].key === row.key) {
            this.teacherScreenList[i].file = null;
            this.teacherScreenList[i].url = "";
            this.teacherScreenList[i].showFile = true;
          }
        }
      } else {
        for (let i = 0; i < this.parentScreenList.length; i++) {
          if (this.parentScreenList[i].key === row.key) {
            this.parentScreenList[i].file = null;
            this.parentScreenList[i].url = '';
            this.parentScreenList[i].showFile = true;
          }
        }
      }
    },

    beforeRemove(file) {
      return this.$confirm(`Cancel the transfert of ${file.name} ?`);
    },
    handlePictureCardPreview(row, file) {
      if (this.updateTemplateAppRequest.appType === "plus") {
        for (let i = 0; i < this.plusScreenList.length; i++) {
          if (this.plusScreenList[i].key === row.key) {
            this.plusScreenList[i].url = file.url;
            this.plusScreenList[i].dialogImg = true;
          }
        }
      } else if (this.updateTemplateAppRequest.appType === "teacher") {
        for (let i = 0; i < this.teacherScreenList.length; i++) {
          if (this.teacherScreenList[i].key === row.key) {
            this.teacherScreenList[i].url = file.url;
            this.teacherScreenList[i].dialogImg = true;
          }
        }
      } else {
        for (let i = 0; i < this.parentScreenList.length; i++) {
          if (this.parentScreenList[i].key === row.key) {
            this.parentScreenList[i].url = file.url;
            this.parentScreenList[i].dialogImg = true;
          }
        }
      }
    },


    showImageTemplate(urlImageTemplate) {
      console.log(urlImageTemplate)
      this.urlImgQrCode = urlImageTemplate;
      this.dialogImg = true;
    },


    handleChangePicture(row, file) {
      if (this.updateTemplateAppRequest.appType === "plus") {
        for (let i = 0; i < this.plusScreenList.length; i++) {
          if (this.plusScreenList[i].key === row.key) {
            this.plusScreenList[i].file = file;
            this.plusScreenList[i].url = file.url;
            this.plusScreenList[i].showFile = false;
          }
        }
      } else if (this.updateTemplateAppRequest.appType === "teacher") {
        for (let i = 0; i < this.teacherScreenList.length; i++) {
          if (this.teacherScreenList[i].key === row.key) {
            this.teacherScreenList[i].file = file;
            this.teacherScreenList[i].url = file.url;
            this.teacherScreenList[i].showFile = false;
          }
        }
      } else {
        for (let i = 0; i < this.parentScreenList.length; i++) {
          if (this.parentScreenList[i].key === row.key) {
            this.parentScreenList[i].file = file;
            this.parentScreenList[i].url = file.url;
            this.parentScreenList[i].showFile = false;
          }
        }
      }
      this.checkedKeepPhoto = false
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isPNG) {
        this.$message.error("Ảnh phải có dạng JPG hoặc PNG!");
        this.handleRemove(file);
      }
      if (!isLt5M) {
        this.$message.error("Ảnh không thể vượt quá 5MB");
        this.handleRemove(file);
      }
      return isJPG && isLt5M;
    },

    handleTypeApp() {
      if (this.updateTemplateAppRequest.appType !== 'plus') {
        this.typePackage = 'template'
      }
    },

    handleChangeDisplayTicket() {
      this.listTicketUpdate = []
      this.titleTicket = this.getNameTicket(this.displayTicket)
      switch (this.displayTicket) {
        case 1: {
          this.listTicketUpdate = this.listTicketLearnShow
          this.fileListTicket = this.listTicketLearn
          break;
        }
        case 2: {
          this.listTicketUpdate = this.listTicketEatShow
          this.fileListTicket = this.listTicketEat
          break;
        }
        case 3: {
          this.listTicketUpdate = this.listTicketSleepShow
          this.fileListTicket = this.listTicketSleep
          break;
        }
        case 4: {
          this.listTicketUpdate = this.listTicketToiletShow
          this.fileListTicket = this.listTicketToilet
          break;
        }
        case 5: {
          this.listTicketUpdate = this.listTicketHealthyShow
          this.fileListTicket = this.listTicketHealthy
          break;
        }
        case 6: {
          this.listTicketUpdate = this.listTicketCommentShow
          this.fileListTicket = this.listTicketComment
          break;
        }
        case 7: {
          this.listTicketUpdate = this.listTicketWeekShow
          this.fileListTicket = this.listTicketWeek
          break;
        }
        case 8: {
          this.listTicketUpdate = this.listTicketMonthShow
          this.fileListTicket = this.listTicketMonth
          break;
        }
        case 9: {
          this.listTicketUpdate = this.listTicketPeriodicShow
          this.fileListTicket = this.listTicketPeriodic
          break;
        }
      }
    },
    handleChangeTypeTicket() {
      if (this.typePackage === 'ticket') {
        this.handleChangeDisplayTicket()
      }
    },

    // Chọn ảnh phiếu bé ngoan
    handleChangePictureTicket(file, fileList) {
      this.fileListTicket = fileList
      switch (this.displayTicket) {
        case 1: {
          this.listTicketLearn = this.fileListTicket
          break;
        }
        case 2: {
          this.listTicketEat = this.fileListTicket
          break;
        }
        case 3: {
          this.listTicketSleep = this.fileListTicket
          break;
        }
        case 4: {
          this.listTicketToilet = this.fileListTicket
          break;
        }
        case 5: {
          this.listTicketHealthy = this.fileListTicket
          break;
        }
        case 6: {
          this.listTicketComment = this.fileListTicket
          break;
        }
        case 7: {
          this.listTicketWeek = this.fileListTicket
          break;
        }
        case 8: {
          this.listTicketMonth = this.fileListTicket
          break;
        }
        case 9: {
          this.listTicketPeriodic = this.fileListTicket
          break;
        }
      }
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isPNG) {
        this.$message.error("Ảnh phải có dạng JPG hoặc PNG!");
        this.handleRemoveTicket(file);
        return false; // Trả về false để không thực hiện tiếp tục xử lý
      }
      if (!isLt5M) {
        this.$message.error("Ảnh không thể vượt quá 5MB");
        this.handleRemoveTicket(file);
        return false; // Trả về false để không thực hiện tiếp tục xử lý
      }
      return true;
    },
    // Xem chi tiết ảnh phiếu bé ngoan
    handlePictureCardPreviewTicket(file) {
      this.dialogImageUrlTicket = file.url;
      this.dialogVisibleTicket = true;
    },
    // Xóa file phiếu bé ngoan
    handleRemoveTicket(file) {
      this.$refs.uploadTicket.clearFiles();
      let index;
      for (let i = 0; i < this.fileListTicket.length; i++) {
        if (file.uid === this.fileListTicket[i].uid) {
          index = i
        }
      }
      if (index >= 0) {
        this.fileListTicket.splice(index, 1);
      }
      let indexTicket;
      switch (this.displayTicket) {
        case 1: {
          for (let i = 0; i < this.listTicketLearn.length; i++) {
            if (file.uid === this.listTicketLearn[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketLearn.splice(indexTicket, 1);
          }
          break;
        }
        case 2: {
          for (let i = 0; i < this.listTicketEat.length; i++) {
            if (file.uid === this.listTicketEat[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketEat.splice(indexTicket, 1);
          }
          break;
        }
        case 3: {
          for (let i = 0; i < this.listTicketSleep.length; i++) {
            if (file.uid === this.listTicketSleep[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketSleep.splice(indexTicket, 1);
          }
          break;
        }
        case 4: {
          for (let i = 0; i < this.listTicketToilet.length; i++) {
            if (file.uid === this.listTicketToilet[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketToilet.splice(indexTicket, 1);
          }
          break;
        }
        case 5: {
          for (let i = 0; i < this.listTicketHealthy.length; i++) {
            if (file.uid === this.listTicketHealthy[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketHealthy.splice(indexTicket, 1);
          }
          break;
        }
        case 6: {
          for (let i = 0; i < this.listTicketComment.length; i++) {
            if (file.uid === this.listTicketComment[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketComment.splice(indexTicket, 1);
          }
          break;
        }
        case 7: {
          for (let i = 0; i < this.listTicketWeek.length; i++) {
            if (file.uid === this.listTicketWeek[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketWeek.splice(indexTicket, 1);
          }
          break;
        }
        case 8: {
          for (let i = 0; i < this.listTicketMonth.length; i++) {
            if (file.uid === this.listTicketMonth[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketMonth.splice(indexTicket, 1);
          }
          break;
        }
        case 9: {
          for (let i = 0; i < this.listTicketPeriodic.length; i++) {
            if (file.uid === this.listTicketPeriodic[i].uid) {
              indexTicket = i
            }
          }
          if (indexTicket >= 0) {
            this.listTicketPeriodic.splice(indexTicket, 1);
          }
          break;
        }
      }
    },

    deletePicture(id) {
      this.$confirm("Bạn có chắc chắn muốn xóa ảnh đã chọn?", "Thông báo!", {
        distinguishCancelAndClose: true,
        confirmButtonText: "Có",
        closeOnClickModal: false,
        cancelButtonText: "Không",
      }).then(() => {
        let indexTicket;
        switch (this.displayTicket) {
          case 1: {
            for (let i = 0; i < this.listTicketLearnShow.length; i++) {
              if (id === this.listTicketLearnShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketLearnShow.splice(indexTicket, 1);
            }
            break;
          }
          case 2: {
            for (let i = 0; i < this.listTicketEatShow.length; i++) {
              if (id === this.listTicketEatShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketEatShow.splice(indexTicket, 1);
            }
            break;
          }
          case 3: {
            for (let i = 0; i < this.listTicketSleepShow.length; i++) {
              if (id === this.listTicketSleepShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketSleepShow.splice(indexTicket, 1);
            }
            break;
          }
          case 4: {
            for (let i = 0; i < this.listTicketToiletShow.length; i++) {
              if (id === this.listTicketToiletShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketToiletShow.splice(indexTicket, 1);
            }
            break;
          }
          case 5: {
            for (let i = 0; i < this.listTicketHealthyShow.length; i++) {
              if (id === this.listTicketHealthyShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketHealthyShow.splice(indexTicket, 1);
            }
            break;
          }
          case 6: {
            for (let i = 0; i < this.listTicketCommentShow.length; i++) {
              if (id === this.listTicketCommentShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketCommentShow.splice(indexTicket, 1);
            }
            break;
          }
          case 7: {
            for (let i = 0; i < this.listTicketWeekShow.length; i++) {
              if (id === this.listTicketWeekShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketWeekShow.splice(indexTicket, 1);
            }
            break;
          }
          case 8: {
            for (let i = 0; i < this.listTicketMonthShow.length; i++) {
              if (id === this.listTicketMonthShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketMonthShow.splice(indexTicket, 1);
            }
            break;
          }
          case 9: {
            for (let i = 0; i < this.listTicketPeriodicShow.length; i++) {
              if (id === this.listTicketPeriodicShow[i].id) {
                indexTicket = i
              }
            }
            if (indexTicket >= 0) {
              this.listTicketPeriodicShow.splice(indexTicket, 1);
            }
            break;
          }
        }
        this.listIdTicketDelete.push(id)
        this.$message({
          message: "Xóa ảnh thành công",
          type: "success",
        });
      });
    },

  },
};
</script>
<style>
.hideUpload > div {
  visibility: hidden;
}
</style>
<style lang="scss" scoped>

/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-button--primary {
  width: 100%;
  background: #409eff;
}

/deep/ .upload-demo {
  text-align: center;

  .el-upload {
    width: 100%;
  }
}

/deep/ .el-avatar {
  display: inline;

  img {
    border-radius: 5px;
    width: 100%;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  text-align: center;
  color: #d13b93;
  font-weight: bold;
}

/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.el-select {
  display: block;
}

.tab-infor-button {
  text-align: right;
  margin-top: 20px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.group-radio-status {
  margin: 0 50px;

  .kids-status {
    margin-bottom: 10px;
  }
}

/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #67c23a;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

/deep/ .el-upload--picture-card {
  background: none;
  border-radius: 6px;
  border: none; /* Default border */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  cursor: pointer;
  line-height: 146px;
  vertical-align: top;
}

/deep/ .el-table th.gutter {
  background-color: #78a5e7;
}

/deep/ .el-image__error {
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: #ffffff;
  vertical-align: middle;
}

.app_name {
  display: inline-block;
  margin: 0;
  text-transform: capitalize;
  font-size: 15px;
  padding: 0 12px;
  cursor: not-allowed;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/deep/ .el-upload-list__item.is-ready > div {
  height: 100%;
}

/deep/ .el-image__inner {
  object-fit: cover;
}

.tag_image {
  background: #409effe6;
  position: absolute;
  left: -20px;
  top: -4px;
  width: 60px;
  padding: 6px 0 0 0;
  text-align: center;
  color: #fff;
  rotate: -45deg;
  font-size: 12px;
  text-transform: capitalize;
}

.btn_nav {
  background-color: #ecf4ff;
  display: flex;
  padding: 6px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.8s ease-in-out;
}

.btn_nav:hover {
  background-color: #d3e4fb;
}
</style>
